<script>
  import resources from './resources'

  export default {
    name: 'scheduling-patient-cancel',
    mixins: [resources]
  }
</script>

<template lang="pug">
  .col-xs-12.col-sm-10.col-sm-offset-1
    h4 TEM CERTEZA QUE DESEJA CANCELAR ESTE AGENDAMENTO?
    .row.border-bottom
      .col-xs-12.col-sm-8.margin-bottom
        small.grey Dia
        br
        span.blue {{ schedule.date }} ({{ day }})
      .col-xs-12.col-sm-4.margin-bottom
        small.grey Hora
        br
        span.blue {{ schedule.time }}
    .row.border-bottom
      .col-xs-12.col-sm-6.margin-bottom
        small.grey Nome do Profissional
        br
        span.blue {{ schedule.agenda.professional.name }}
        .especialidade Clínica Médica
        .endereco
          | {{ schedule.agenda.address.label }}
          br
          | {{ schedule.agenda.address.label2 }}
      .col-xs-12.col-sm-6
        small.grey Nome do Paciente
        br
        span.blue {{ schedule.patient.name }}
        .detalhes(v-if="schedule.patient.degree")
         strong {{ schedule.patient.degree.name }}
        .detalhes(v-if="!schedule.patient.degree")
          strong Titular


    .row.border-bottom.dark-grey
      .col-xs-12(style='margin-bottom:5px;margin-left:-5px;color:#ed193b;')
        span.icon 
        | Políticas de Cancelamento
      .hidden-xs.col-sm-3.grey(style='line-height:100%; margin:10px 0px;')
        span.small-modal
          | Descrição
          br
          | da Regra
      //-- .hidden-xs.col-sm-4.grey(style='line-height:100%; margin:10px 0px;')
        span.small-modal
          | Consulta
          br
          | Garantida*
      .hidden-xs.col-sm-4.col-sm-offset-1.grey(style='line-height:100%; margin:10px 0px;')
        span.small-modal Penalidade*
        br
      .clearfix

      .col-xs-12.col-sm-3
        span.small-modal.hidden-sm.hidden-md.hidden-lg.grey
          | Descrição da Regra
          br
        span.small-modal Até 48 horas
      //--.col-xs-12.col-sm-4
        span.small-modal.hidden-sm.hidden-md.hidden-lg.grey
          | Consulta Garantida*
          br
        span.small-modal R$ 0,00
      //-.col-xs-12.col-sm-1.grey
        span.small-modal ou
      .col-xs-12.col-sm-4
        span.small-modal.hidden-sm.hidden-md.hidden-lg.grey
          | Penalidade*
          br
        span.small-modal Não há penalidade
      .clearfix

      .border-bottom.hidden-sm.hidden-md.hidden-lg
      .col-xs-12.col-sm-3
        span.small-modal.hidden-sm.hidden-md.hidden-lg.grey
          | Descrição da Regra
          br
        span.small-modal Até 24 horas
      //-.col-xs-12.col-sm-4
        span.small-modal.hidden-sm.hidden-md.hidden-lg.grey
          | Consulta Garantida*
          br
        span.small-modal R$ 15,00
      //-.col-xs-12.col-sm-1.grey
        span.small-modal ou
      .col-xs-12.col-sm-6
        span.small-modal.hidden-sm.hidden-md.hidden-lg.grey
          | Penalidade*
          br
        span.small-modal Bloqueio após 3º cancelamento no mês
      .clearfix

      .border-bottom.hidden-sm.hidden-md.hidden-lg
      .col-xs-12.col-sm-3
        span.small-modal.hidden-sm.hidden-md.hidden-lg.grey
          | Descrição da Regra
          br
        span.small-modal < 24 horas
      //-.col-xs-12.col-sm-4
        span.small-modal.hidden-sm.hidden-md.hidden-lg.grey
          | Consulta Garantida*
          br
        span.small-modal Valor da Consulta
      //-.col-xs-12.col-sm-1.grey
        span.small-modal ou
      .col-xs-12.col-sm-6
        span.small-modal.hidden-sm.hidden-md.hidden-lg.grey
          | Penalidade*
          br
        span.small-modal  Bloqueio após 2º cancelamento no mês
      .clearfix

    .buttons-wrapper
      button.btn.cancel(data-dismiss='modal')
        span.icon 
        |  Não, Voltar
      button.btn.save(@click.prevent="doCancel()")
        span.icon 
        |  Sim, Cancelar
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/schedulings/scheduled/index/components/cancel/cancel.vue